import { DateRange } from 'inscreva-sse-models';
import moment from 'moment';

export abstract class EventDateHelper {
  public static isSameDay(date: DateRange) {
    return (
      moment(date.end).endOf('day').diff(moment(date.start).startOf('day'), 'days') === 0 ||
      moment(date.end).diff(date.start, 'days') === 0
    );
  }

  public static isBetween(date: DateRange, rangeToCompare: DateRange) {
    return (
      moment(date.start).isBetween(rangeToCompare.start, rangeToCompare.end, null, '[]') ||
      moment(date.end).isBetween(rangeToCompare.start, rangeToCompare.end, null, '[]')
    );
  }

  private static getFormattedDate(date: string, sameDay?: boolean): string {
    return (date && moment(date).format(!sameDay ? 'DD/MM/YYYY ' : '')) || '';
  }

  public static getDate(date: DateRange, showHour = true): string {
    return (
      (date.start &&
        date.end &&
        ` ( ${this.getFormattedDate(date.start)}${
          !this.isSameDay(date) ? ` - ${this.getFormattedDate(date.end)}` : ''
        } ${showHour ? ` | ${moment(date.start).format('HH:mm')} à ${moment(date.end).format('HH:mm')}` : ''} )`) ||
      ''
    );
  }
}
